import { isDev } from "app/general"

const customMiddleware = (store: any) => (next: any) => async (action: any) => {
  if (action?.response?.status === 401) {
     isDev && console.log("UNAUTHORIZED")
  }
  
  return next(action)
}

export default customMiddleware
